import { INewProduct } from '../../../interfaces/NewProduct.interfaces';
import { customAxios } from '../../common/customAxios';

/**
 * 새로운 상품 목록을 조회하는 API 함수
 * @returns Promise<INewProduct[]> 새로운 상품 목록
 */
export const getNewProducts = (): Promise<INewProduct[]> => {
  return customAxios.get('/market/new-products');
};
